export default {"src":"/_next/static/media/0x8ff795a6f4d97e7887c79bea79aba5cc76444adf.be71efcd.svg","height":788,"width":788,"blurWidth":0,"blurHeight":0};